import { createTokenQueryServiceInstance } from 'src/app/core/services/query-wsz.service';
import { QueryState } from 'src/app/core/models/query.model';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { ITableColumn } from 'src/app/core/models/table.model';
import { IWaterSupplyZone, IWaterSupplyZoneGeo } from './water-supply-zone.model';




export const WATERSUPPLYZONE_GEO_ENDPOINT = 'wsz/all';
export const WATERSUPPLYZONE_GEO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(WATERSUPPLYZONE_GEO_ENDPOINT);


export const waterSupplyZoneGeoStateConfig: SignalStoreConfig<QueryState<IWaterSupplyZoneGeo>> = {
  initState: {
    list: []
  }
}


export const WATERSUPPLYZONE_GEO_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'id',
    primaryKey: true,
    visible: false
  },
  {
    name: 'nome',
    label: 'Nome',
    field: 'nome',
  },
  {
    name: 'resourceTitle',
    label: 'Codice',
    field: 'resourceTitle',
  },
  {
    name: 'idAreraGestore',
    label: 'Gestore',
    field: 'idAreraGestore',
    cell:(element:any)=>element.idAreraGestore ? (element.idAreraGestore[0]?.denominazione ?  element.idAreraGestore[0]?.denominazione  : "") : ""
  },
  {
    name: 'isOverLap',
    label: 'Sovrapposizioni',
    field: 'isOverLap',
    cell: (row: any) => row.isOverLap ? `<mat-icon matTooltip="warning" class="mat-mdc-tooltip-trigger text-red-400 material-symbols-outlined">warning</mat-icon>` : `<mat-icon matTooltip="done" class="mat-mdc-tooltip-trigger text-green-400 material-symbols-outlined">done</mat-icon>`,
  },
];